export default "__VITE_ASSET__CqY$qbTV__"